export default {
	namespaced: true,
	state: {
		modalsRegister: new Set(),
		openedModals: new Set(),
		bodyLocked: false,
	},
	mutations: {
		addModalRegister(state, modalName) {
			state.modalsRegister.add(modalName);
		},
		addModalOpened(state, modalName) {
			state.openedModals.add(modalName);
		},
		deleteModalOpened(state, modalName) {
			state.openedModals.delete(modalName);
		},
		setBodyLock(state, value) {
			state.bodyLocked = value;
		},
	},
	actions: {
		registerModal({state,commit}, modalName) {
			if (state.modalsRegister.has(modalName)) {
				throw new Error(`${modalName}: has already been registered`);
			}
			commit('addModalRegister', modalName);
		},
		openModal({state,commit,dispatch}, modalName) {
			if (!state.modalsRegister.has(modalName)) {
				throw new Error(`${modalName}: has not been registered`);
			}

			if (state.openedModals.has(modalName)) {
				console.error(`${modalName}: has already been opened`);
				return;
			}

			commit('addModalOpened', modalName);

			if (!state.bodyLocked) {
				dispatch('_lockBody')
			}
		},
		closeModal({state,commit,dispatch}, modalName) {
			if (!state.modalsRegister.has(modalName)) {
				throw new Error(`${modalName}: has not been registered`);
			}

			if (!state.openedModals.has(modalName)) {
				console.error(`${modalName}: has not been opened`);
				return;
			}

			commit('deleteModalOpened', modalName);

			if (!state.hasActiveModals && state.bodyLocked) {
				dispatch('_unlockBody')
			}
		},
		_lockBody({commit}) {
			const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
			document.body.style.setProperty('--scrollbar-compensate', `${scrollbarWidth}px`);
			document.body.classList.add('modal-lock');
			commit('setBodyLock', true);
		},
		_unlockBody({commit}) {
			document.body.style.removeProperty('--scrollbar-compensate');
			document.body.classList.remove('modal-lock');
			commit('setBodyLock', false);
		},
	},
	getters: {
		getModalOpened: (state) =>  Array.from(state.openedModals),
		isModalOpened: (state) => (modalName) => state.openedModals.has(modalName),
		hasActiveModals: (state) => state.openedModals.size > 0,
		getConfirmModalOptions: (state) => state.confirmModal,
	}
}